import type {
  DateField,
  ImageField,
  RichTextField,
  SelectField,
} from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { memo } from 'react';

import { DateTopicInfo } from '@/components/DateTopicInfo/DateTopicInfo';

import { OptimizedPrismicImage } from '@/components';
import styles from './articleHero.module.scss';

interface ArticleHeroProps {
  topic: SelectField<'Debt Consolidation' | 'HELOC' | 'Personal loans'>;
  date: DateField;
  title: RichTextField;
  image: ImageField<never>;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

const ArticleHeroComponent = ({
  date,
  image,
  title,
  topic,
}: ArticleHeroProps) => {
  return (
    <article className={styles.hero}>
      <DateTopicInfo date={date} topic={topic} fontSize="regular" />
      <PrismicRichText field={title} components={components} />
      <figure className={styles.image_wrapper}>
        <OptimizedPrismicImage field={image} className={styles.image} />
      </figure>
    </article>
  );
};

export const ArticleHero = memo(ArticleHeroComponent);
